import React from "react";
import * as styles from "./grey-chip.module.scss";

export interface GreyChipProps {
	children: React.ReactNode;
}

export default function GreyChip(props: GreyChipProps) {
	return <span className={styles.container}>{props.children}</span>;
}
